<template>
  <div class="container" v-if="isReady">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <cart-tabs
          ref="cartTab"
          :collections="collections"
          :initial-collection-index="getInitialCollectionIndex()"
          class="cart-tab-buttons"
          color-button="pz"
          @activeCollectionHasChanged="updateActiveCollection"
        >
          <template slot="header">
            <div class="card-icon">
              <md-icon>shopping_cart</md-icon>
            </div>
            <div>
              <h4 class="title" style="display: inline-flex">{{ cartName }}</h4>
              <div v-if="!defaultCart" style="display: inline-flex">
                <md-icon>info</md-icon>
                <md-tooltip md-direction="bottom">{{ cartMessage }}</md-tooltip>
              </div>
            </div>

            <div class="md-layout">
              <div class="md-layout-item md-size-5 ml-auto">
                <md-button
                  class="md-simple cart-tools"
                  v-on:click="showMediaSizeModal()"
                >
                  <md-icon>info</md-icon>
                  <span>Cart media: {{ mediaSize }}</span>
                </md-button>
              </div>
              <div
                v-if="defaultCart && canShareCart"
                class="md-layout-item md-size-5 ml-auto"
              >
                <md-button
                  class="md-simple cart-tools"
                  v-on:click="showShareCartModal()"
                >
                  <md-icon>ios_share</md-icon>
                  <span>Share cart</span>
                </md-button>
              </div>
              <div v-if="canEditCart" class="md-layout-item md-size-5 ml-auto">
                <md-button class="md-simple cart-tools" v-on:click="saveCart()">
                  <md-icon>save</md-icon>
                  <span>Save cart</span>
                </md-button>
              </div>
              <div class="md-layout-item md-size-5 ml-auto">
                <md-button
                  class="md-simple cart-tools"
                  v-on:click="openContentPage()"
                >
                  <md-icon>shopping_cart</md-icon>
                  <span>Add more content</span>
                </md-button>
              </div>

              <div class="md-layout-item md-size-5 ml-auto">
                <md-button class="md-simple cart-tools" @click="clearCart">
                  <md-icon>remove_shopping_cart</md-icon>
                  <span>Clear cart</span>
                </md-button>
              </div>
              <div class="md-layout-item md-size-20 ml-auto text-download">
                <md-field>
                  <label class="col-md-4">Name</label>
                  <md-input v-model="downloadName" type="text"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-20">
                <md-button
                  v-on:click="confirmDownloadCart()"
                  class="small-alert-modal download-button md-sm"
                  v-bind:class="{
                    disabled: this.$store.state.cart.length === 0 || disableCreatePackageButton,
                  }"
                >
                  <md-icon>create_new_folder</md-icon>
                  Create Package
                </md-button>
              </div>
            </div>
          </template>
          <template slot="tab-panel-content">
            <div class="md-layout">
              <div
                class="md-layout-item column-size-25"
                v-if="activeCollectionHasInclude"
              >
                <div class="typo__label">Include</div>
                <multiselect
                  v-model="collectionCartConfigs[activeCollectionIndex].include"
                  placeholder="Select content to export"
                  :options="includeContentInitial"
                  :closeOnSelect="false"
                  :multiple="true"
                  :searchable="false"
                  :taggable="true"
                  @input="calculateMediaSize"
                ></multiselect>
              </div>
              <div class="md-layout-item column-size-25-max">
                <div class="typo__label">Media resolution</div>
                <multiselect
                  v-model="
                    collectionCartConfigs[activeCollectionIndex].mediaResolution
                  "
                  :options="this.$store.state.mediaFormats"
                  track-by="id"
                  label="name"
                  :multiple="false"
                  :searchable="false"
                  :allowEmpty="false"
                  :disabled="!this.mediaSelected"
                  @input="calculateMediaSize"
                ></multiselect>
              </div>
              <div
                class="md-layout-item column-size-25"
                v-if="activeCollectionHasLanguages"
              >
                <div class="typo__label">Languages</div>
                <multiselect
                  v-model="
                    collectionCartConfigs[activeCollectionIndex].languages
                  "
                  placeholder="Select languages to export"
                  label="value"
                  track-by="key"
                  :options="this.$store.state.user.languages"
                  :closeOnSelect="false"
                  :multiple="true"
                  :searchable="false"
                  :taggable="true"
                  :allowEmpty="false"
                  :limit="3"
                  :disabled="!this.textSelected"
                ></multiselect>
              </div>
              <div
                class="md-layout-item column-size-25"
                v-if="activeCollectionHasPrices"
              >
                <div class="typo__label">Prices</div>
                <multiselect
                  v-model="collectionCartConfigs[activeCollectionIndex].prices"
                  placeholder="Select prices to export"
                  label="label"
                  track-by="id"
                  :options="this.$store.state.activeEnvironment.prices"
                  :closeOnSelect="false"
                  :multiple="true"
                  :searchable="false"
                  :taggable="true"
                  :disabled="!this.textSelected"
                ></multiselect>
              </div>
            </div>
            <div class="md-layout">
              <span class="no-content" v-if="!activeCollectionHasSelectedItems"
                >No selection made</span
              >
              <md-card
                v-for="document in activeCollectionSelectedDocuments"
                :key="document.id"
                class="
                  md-layout-item md-medium-size-50 md-xsmall-size-50 md-size-15
                  content-area-large
                  center-align
                "
              >
                <div v-on:click.stop="showDetailsModalare(document)">
                  <div class="card-desription2" :title="document.description">
                    {{ document.description }}
                  </div>
                  <div class="card-image-container">
                    <img v-if="document.thumbnail != ''" :src="document.thumbnail" />
                    <img class="no-image" v-else src="/img/no-image.png" />
                  </div>
                  <div class="card-title2" :title="document.name">
                    {{ document.name }}
                  </div>

                  <div class="cart-button">
                    <md-button
                      v-on:click.stop="removeFromCart(document)"
                      class="md-sm remove-from-cart"
                      >Remove
                    </md-button>
                  </div>
                </div>
              </md-card>
            </div>
          </template>
        </cart-tabs>
      </div>
    </div>

    <modal v-if="showDetailsModal" @close="detailsModalHide">
      <template slot="header">
        <h4 class="modal-title">{{ this.details.name }}</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="detailsModalHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <div class="popup-container">
          <div v-if="downloading" class="center-div">
            <dot-loader></dot-loader>
          </div>
          <div v-else class="md-layout">
            <div
              class="
                md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-75
              "
            >
              <div class="md-layout">
                <div
                  class="
                    md-layout-item
                    md-medium-size-50
                    md-xsmall-size-100
                    md-size-80
                    center-image
                  "
                >
                  <div
                    v-if="
                      this.details.selectedMedia.isVideo
                    "
                    class="flex-center"
                  >
                    <video
                      controls
                      controlsList="nodownload"
                      preload="metadata"
                    >
                      <source
                        :src="this.details.selectedMedia.url"
                        type="video/mp4"
                      />
                      >
                    </video>
                  </div>
                  <div v-else class="flex-center">
                    <table
                      width="100%"
                      height="100%"
                      align="center"
                      valign="center"
                    >
                      <tr>
                        <td>
                          <img
                            v-if="this.details.selectedMedia.url != null"
                            id="selectedImage"
                            style="max-height: 400px;"
                            :src="this.details.selectedMedia.url"
                          />
                          <img class="no-image" v-else src="/img/no-image.png" />
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div
                  v-if="this.details.media.length > 1"
                  class="
                    modal-text-area
                    center-image
                    md-layout-item
                    md-medium-size-50
                    md-xsmall-size-100
                    md-size-20
                  "
                >
                  <md-card
                    v-for="(m, index) in this.details.media"
                    :key="index"
                    class="popup-media-box"
                  >
                    <div
                      class="card-image-container-popup"
                      v-on:click="details.selectedMedia = m"
                    >
                      <img :src="m.thumbnail" />
                    </div>
                    <div class="card-title-popup">
                      <span>{{ m.name }}</span>
                    </div>
                  </md-card>
                </div>
              </div>
            </div>

            <div
              class="
                md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25
                media-text
                modal-text-area
              "
            >
              <div
                style="max-width: 700px;"
                v-for="(key, index) in Object.keys(this.details.properties)"
                :key="index"
              >
                <div v-if="details.properties[key]" class="details-label">
                  {{ details.map[key].label }}
                </div>
                <div v-if="details.properties[key]" class="details-field">
                  {{ details.properties[key] }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <md-button
          class="md-sm remove-from-cart-modal"
          v-bind:class="{ disabled: this.details.name === 'Removed from cart' }"
          v-on:click="removeFromCartByKey()"
          >Remove from Cart
        </md-button>
        <md-button class="md-simple" @click="getPreviousDetail"
          >&lt; Previous
        </md-button>
        <md-button class="md-simple" @click="getNextDetail">Next ></md-button>
        <md-button class="md-simple" @click="detailsModalHide">Close</md-button>
      </template>
    </modal>
    <modal
      v-if="termsAndConditionsModal"
      @close="termsAndConditionsModalHide"
      class="confirmPrices"
    >
      <template slot="header">
        <h4 class="modal-title">
          {{ this.$store.state.termsAndConditions.termsAndConditionsHeader }}
        </h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="termsAndConditionsModalHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <div
          v-html="
            this.$store.state.termsAndConditions.termsAndConditionsContent
          "
        ></div>

        <md-checkbox v-model="confirmPrices" class="acknowledge-label"
          ><p
            v-on:click.stop="navigate()"
            v-html="
              this.$store.state.termsAndConditions.termsAndConditionsApprove
            "
          ></p
        ></md-checkbox>
      </template>

      <template slot="footer">
        <md-button
          class="md-sm remove-from-cart-modal"
          v-bind:class="{ disabled: !confirmPrices }"
          @click="downloadCart"
          >Continue
        </md-button>
      </template>
    </modal>
    <modal
      v-if="mediaSizeModal"
      @close="mediaSizeModalHide"
      class="confirmPrices"
    >
      <template slot="header">
        <h4 class="modal-title">Estimated Media Size</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="mediaSizeModalHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <p>
          Estimated size for all media in the cart, with the selected
          resolution, is
          <b>{{ this.mediaSize }}</b>
        </p>
      </template>
    </modal>
    <modal
      v-if="shareCartModal"
      @close="shareCartModalHide"
      class="confirmPrices"
    >
      <template slot="header">
        <h4 class="modal-title">Share cart</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="shareCartModalHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <shared-cart-details-form :shareCartModel="shareCartModel" />
      </template>

      <template slot="footer">
        <md-button @click="shareCartModalHide" class="md-simple"
          >Close</md-button
        >
        <md-button
          style="margin-left: 8px"
          class="md-primary"
          @click="shareCart"
          >Share</md-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import { CartTabs } from "@/components";
import { SharedCartDetailsForm } from "@/components";
import CartService from "@/services/CartService";
import DetailService from "@/services/DetailService";
import { Modal, DotLoader } from "@/components";
import $ from "jquery";
import Multiselect from "vue-multiselect";
import store from "@/store";

export default {
  components: {
    CartTabs,
    Modal,
    DotLoader,
    Multiselect,
    SharedCartDetailsForm,
  },
  mounted() {
    this.initCart();
  },
  data() {
    return {
      activeCollection: null,
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },
      classicModal: false,
      noticeModal: false,
      termsAndConditionsModal: false,
      confirmPrices: false,
      downloadName: this.getDownloadName(),
      showDetailsModal: false,
      shareCartModal: false,
      radio: true,
      selected: [],
      details: {
        name: "Loading...",
        type: "",
      },
      downloading: false,
      shareCartModel: {
        id: "",
        name: "",
        message: "",
        expirationDate: new Date().toISOString().slice(0, 10),
        notifyUsers: false,
        sharedWithUsers: [],
        environmentId: "",
      },
      products: [],
      media: [],
      cartItems: [],
      cartName: "Cart",
      cartMessage: "",
      canEditCart: false,
      defaultCart: false,
      mediaSize: "0 bytes",

      includeContentInitial: ["Product Media", "Product Text"],

      initialCollectionCartConfig: {
        include: ["Product Media", "Product Text"],
        mediaResolution: { id: "Medium", name: "Medium" },
        languages: this.$store.state.user.languages,
        prices: [],
      },
      collectionCartConfigs: [],

      mediaSizeModal: false,
      disableCreatePackageButton: false
    };
  },
  computed: {
    activeCollectionIndex: function () {
      return this.collections.indexOf(this.activeCollection);
    },
    activeCollectionSelectedDocuments: function () {
      if (this.activeCollection)
        return this.getSelectedItemsForCollection(this.activeCollection.type);
      return null;
    },
    activeCollectionIsMediaOnly: function () {
      return this.activeCollection && this.activeCollection.isMediaOnly;
    },
    activeCollectionHasInclude: function () {
      return !this.activeCollectionIsMediaOnly;
    },
    activeCollectionHasLanguages: function () {
      return !this.activeCollectionIsMediaOnly;
    },
    activeCollectionHasPrices: function () {
      return !this.activeCollectionIsMediaOnly;
    },
    activeCollectionHasSelectedItems: function () {
      return (
        this.activeCollectionSelectedDocuments &&
        this.activeCollectionSelectedDocuments.length > 0
      );
    },
    activeEnvironment: function () {
      return store.state.activeEnvironment;
    },
    collections: function () {
      return this.activeEnvironment.collections;
    },
    downloads: function (){
      return this.$store.state.downloading;
    },
    mediaFormats: function () {
      return this.$store.state.mediaFormats;
    },
    isReady: function () {
      return (
        this.collections && this.collections.length > 0 && this.activeCollection
      );
    },
    textSelected: {
      get: function () {
        return (
          this.collectionCartConfigs[
            this.activeCollectionIndex
          ].include.indexOf("Product Text") > -1
        );
      },
    },
    mediaSelected: {
      get: function () {
        return (
          this.collectionCartConfigs[
            this.activeCollectionIndex
          ].include.indexOf("Product Media") > -1
        );
      },
    },
    nameValidationClass() {
      return {
        "md-invalid": !this.shareCartModel.name,
      };
    },
    canShareCart() {
      return store.state.user.canShareCart;
    },
  },
  watch: {
    $route() {
      this.initCart();
    },
    collections: function () {
      const index = this.getInitialCollectionIndex();
      this.updateActiveCollection(this.collections[index]);
    },
    mediaFormats: function () {
      this.initMediaFormats();
    },
    downloads: function () {
      let packageStatus = this.downloads.find(obj => obj.name == this.downloadName);
      if(!packageStatus)
        this.disableCreatePackageButton = false;
    },
    isReady: function (nowReady, wasReady) {
      if (nowReady && !wasReady) {
        this.initializeCollectionCartConfigs();
        this.$store.dispatch('getDownloadFormats');
        this.calculateMediaSize();
      }
    },

  },
  methods: {
    initMediaFormats(){
      let media = this.$store.state.mediaFormats.find(
        (obj) => obj.id == "Medium"
      );

      if (media == null) {
        let selectedMediaFormat = this.$store.state.mediaFormats[0];
        this.collectionCartConfigs.forEach((c) => {
          c.mediaResolution = {
            id: selectedMediaFormat.id,
            name: selectedMediaFormat.name,
          };
        });
      } else {
        this.collectionCartConfigs.forEach((c) => {
          c.mediaResolution = {
            id: media.id,
            name: media.name,
          };
        });
      }
    },
    initCart() {
      if (this.collections && this.collections.length > 0) {
        const index = this.getInitialCollectionIndex();
        this.updateActiveCollection(this.collections[index]);
      }

      this.defaultCart = this.$route.params.id == null;
      if (this.$route.params.id) {
        let self = this;
        CartService.GetCart(this.$route.params.id).then((response) => {
          let cart = response.data.result;
          this.shareCartModel.id = cart.id;
          this.shareCartModel.name = cart.name;
          this.shareCartModel.message = cart.name;
          this.cartName = cart.name;
          this.cartMessage = cart.message;
          this.canEditCart = cart.canEditCart;

          if (this.$route.params.loadCartItems == true) {
            self.$store.commit("clearCart");
            cart.cartItems.forEach((el) => self.$store.commit("addToCart", el));
          }
          this.cartItems = self.$store.state.cart;
          this.calculateMediaSize();
        });
      } else {
        this.cartItems = this.$store.state.cart;
      }
      
      this.initMediaFormats();
      this.calculateMediaSize();
    },
    initializeCollectionCartConfigs: function () {
      this.collectionCartConfigs = [];
      this.collections.forEach(() =>
        this.collectionCartConfigs.push(
          JSON.parse(JSON.stringify(this.initialCollectionCartConfig))
        )
      );
    },
    getSelectedItemsForCollection: function (collectionType) {
      if (collectionType)
        return this.$store.getters.selectedItemsForCollection(collectionType);
      return null;
    },
    getInitialCollectionIndex() {
      let index = 0;
      if (this.collections && this.collections.length > 0) {
        const firstCollectionWithSelectedItems = this.collections.find(
          (c) =>
            this.$store.getters.selectedItemsForCollection(c.type).length > 0
        );

        index = this.collections.indexOf(firstCollectionWithSelectedItems);
      }
      return index < 0 ? 0 : index;
    },
    updateActiveCollection(collection) {
      this.activeCollection = collection;
    },
    navigate() {},
    showDetailsModalare(document) {
      this.selected = document;
      this.showDetailsModal = true;
      this.getDetails(document.id, document.type);

      this.downloading = true;
      $("body").css("overflow", "hidden");
    },
    async getDetails(id, type) {
      this.details.name = "Loading...";
      const response = await DetailService.GetDetails(id, type);

      this.details = response.data.result;
      this.details.type = type;
      this.downloading = false;
    },
    getNextDetail() {
      const currentType = this.details.type;
      const currentItemsInTab =
        this.$store.getters.selectedItemsForCollection(currentType);

      const currentItemId = this.details.id;
      const currentItem = currentItemsInTab.find(
        (obj) => obj.id === currentItemId
      );
      const currentItemIndex = currentItemsInTab.indexOf(currentItem);

      const nextItemIndex =
        currentItemIndex + 1 < currentItemsInTab.length
          ? currentItemIndex + 1
          : 0;
      const nextItem = currentItemsInTab[nextItemIndex];

      this.downloading = true;
      this.getDetails(nextItem.id, nextItem.type);
    },
    getPreviousDetail() {
      const currentType = this.details.type;
      const currentItemsInTab =
        this.$store.getters.selectedItemsForCollection(currentType);

      const currentItemId = this.details.id;
      const currentItem = currentItemsInTab.find(
        (obj) => obj.id === currentItemId
      );
      const currentItemIndex = currentItemsInTab.indexOf(currentItem);

      const previousItemIndex =
        currentItemIndex - 1 >= 0
          ? currentItemIndex - 1
          : currentItemsInTab.length - 1;
      const previousItem = currentItemsInTab[previousItemIndex];

      this.downloading = true;
      this.getDetails(previousItem.id, previousItem.type);
    },
    showModalare(document) {
      this.selected = document;
      this.showDetailsModal = true;
      this.getDetails(document.id, document.type);

      this.downloading = true;
      $("body").css("overflow", "hidden");
    },
    detailsModalHide: function () {
      this.showDetailsModal = false;
      $("body").css("overflow", "auto");
    },
    mediaSizeModalHide: function () {
      this.mediaSizeModal = false;
      $("body").css("overflow", "auto");
    },
    showMediaSizeModal: function () {
      $("body").css("overflow", "hidden");
      this.mediaSizeModal = true;
    },
    getDownloadName() {
      const today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1; //January is 0!
      const yyyy = today.getFullYear();

      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      return "Download " + yyyy + "-" + mm + "-" + dd;
    },
    termsAndConditionsModalHide: function () {
      this.termsAndConditionsModal = false;
      this.confirmPrices = false;
    },
    removeFromCart(document) {
      this.disableCreatePackageButton = false;
      this.$store.commit("removeFromCart", document);
      this.calculateMediaSize();
    },
    removeFromCartByKey() {
      const currentType = this.details.type;
      const currentItemsInTab =
        this.$store.getters.selectedItemsForCollection(currentType);

      const currentItemId = this.details.id;
      const currentItem = currentItemsInTab.find(
        (obj) => obj.id === currentItemId
      );
      const currentItemIndex = currentItemsInTab.indexOf(currentItem);

      const previousItemIndex =
        currentItemIndex - 1 >= 0
          ? currentItemIndex - 1
          : currentItemsInTab.length - 1;
      const previousItem = currentItemsInTab[previousItemIndex];

      this.removeFromCart(currentItem);

      this.details = {
        id: previousItem.id,
        name: "Removed from cart",
        type: currentType,
        media: [],
        selectedMedia: { url: "" },
        properties: [],
      };
      this.detailsModalHide();
    },
    confirmDownloadCart() {
      if (
        this.$store.state.termsAndConditions.termsAndConditionsContent !=
          null &&
        this.$store.state.termsAndConditions.termsAndConditionsContent.length >
          0
      ) {
        this.termsAndConditionsModal = true;
      } else {
        this.downloadCart();
      }
    },
    getCollectionConfigs: function () {
      const cartVue = this;
      return this.collectionCartConfigs.map((c, i) => ({
        collectionType: cartVue.collections[i].type,
        collectionDisplayName: cartVue.collections[i].displayName,
        mediaRequired:
          cartVue.collections[i].isMediaOnly ||
          c.include.indexOf("Product Media") > -1,
        textRequired:
          !cartVue.collections[i].isMediaOnly &&
          c.include.indexOf("Product Text") > -1,
        prices: c.prices,
        languages: c.languages,
        mediaFormat: c.mediaResolution.id, // === "Medium" ? 0 : 1
      }));
    },
    async calculateMediaSize() {
      this.disableCreatePackageButton = false;
      if (this.$store.state.cart.length === 0) {
        this.mediaSize = 0;

        return;
      }

      const items = this.$store.state.cart.map((doc) => {
        return { key: doc.id, type: doc.type };
      });

      const collectionConfigs = this.getCollectionConfigs();

      const config = {
        name: this.downloadName,
        items: items,
        collectionConfigs: collectionConfigs,
      };

      const response = await CartService.GetMediaSizes(config);
      this.mediaSize = response.data;
    },
    async downloadCart() {
      this.termsAndConditionsModalHide();

      const items = this.$store.state.cart.map((doc) => {
        return { key: doc.id, type: doc.type };
      });

      const collectionConfigs = this.getCollectionConfigs();

      const config = {
        name: this.downloadName,
        items: items,
        collectionConfigs: collectionConfigs,
      };

      this.disableCreatePackageButton = true;
      const response = await CartService.DownloadCart(config);
      let download = {
        name: this.downloadName,
        id: response.data.result,
        status: "Analysing",
        progress: 0,
      };
      this.$store.commit("addDownloading", download);
      this.notifyVue("Creating package...", download);
    },
    clearCart() {
      this.$store.commit("clearCart");
      this.calculateMediaSize();
    },
    notifyVue(message, download) {
      // var color = 'info'
      var color = "pz";
      this.$notify({
        group: 'package',
        message: message,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: color,
        timeout: 600000,
        download: download
      });
    },
    shareCartModalHide: function () {
      this.shareCartModal = false;
      $("body").css("overflow", "auto");
    },
    showShareCartModal: function () {
      $("body").css("overflow", "hidden");
      this.shareCartModal = true;
    },
    async shareCart() {
      if (!this.shareCartModel.name || !this.shareCartModel.expirationDate)
        return;

      this.shareCartModel.cartItems = this.$store.state.cart;
      this.shareCartModel.environmentId =
        this.$store.state.activeEnvironment.id;

      let response = await CartService.ShareCart(this.shareCartModel);
      this.shareCartModalHide();
      this.notifyVue("Cart was shared");

      this.$router.push({
        name: "SharedCart",
        params: { id: response.data.result },
      });
    },
    openContentPage() {
      if (this.$route.params.id) {
        this.$router.push({
          name: "SharedCartContent",
          params: { cartId: this.$route.params.id },
        });
      } else {
        this.$router.push({ name: "Content" });
      }
    },
    async saveCart() {
      this.shareCartModel.cartItems = this.$store.state.cart;
      this.shareCartModel.environmentId =
        this.$store.state.activeEnvironment.id;
      await CartService.SaveCartItems(this.shareCartModel);
      this.notifyVue("Cart was saved");
    },
  },
};
</script>

<style>
.multiselect__content-wrapper {
  z-index: 3;
}

.multiselect--active {
  z-index: 3;
}

.md-field .md-input,
.md-field .md-textarea {
  font-size: 12px !important;
}

.md-checkbox-label {
  color: black !important;
}

.md-radio-label {
  color: black !important;
}

.md-checkbox.md-checked .md-checkbox-container:after {
  border-color: #3c4858 !important;
}

.md-radio.md-checked .md-radio-container {
  border-color: #3c4858 !important;
}

.md-radio.md-checked .md-radio-container:after {
  background-color: #3c4858 !important;
}

.confirmPrices > div > div {
  max-width: 40% !important;
}

.tab-pane-1 {
  width: 100%;
}

.tab-pane-2 {
  width: 100%;
}
</style>


<style scoped>
.acknowledge-label {
  font-size: 12px;
}

.remove-from-cart-modal {
  border: solid 1px #3c4858;
  background-color: #3c4858 !important;
  color: white !important;
}

.center-div {
  margin: 0 auto;
  width: 100px;
  padding-top: 200px;
}

.no-content {
  margin-top: 40px;
  margin-left: 15px;
}

.download-selection {
  margin-left: 15px;
}

select div:after {
  background-color: #3c4858 !important;
}

.cart-tools div div i {
  color: #3c4858 !important;
}

.cart-tools div div span {
  color: #3c4858 !important;
}

.center-align {
  text-align: center;
}

.eq-container {
  min-height: 500px;
}

.content-area {
  margin: 15px;
  padding: 10px;

  min-height: 220px;
  max-height: 220px;
  min-width: 160px;
  max-width: 160px;
}

.content-area-large {
  margin: 15px;
  padding: 10px;

  min-height: 250px;
  max-height: 250px;
  min-width: 180px;
  max-width: 180px;
  cursor: pointer;
}

.card-title {
  width: 140px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.card-title2 {
  width: 160px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: -5px;
  font-size: 12px;
}

.card-desription2 {
  width: 160px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
}

.content-area div {
  margin-top: 5px;
  font-size: 12px;
  text-align: center;
}

.cart-button {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.remove-from-cart {
  border: solid 1px #a9a9a9;
  background-color: white !important;
  color: #a9a9a9 !important;
}

.remove-from-cart:hover {
  border: solid 1px #3c4858;
  background-color: white !important;
  color: #3c4858 !important;
}

.card-image-container {
  height: 155px;
  width: 155px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-image-container img {
  display: block;
  margin: auto;

  height: auto;
  max-height: 100px;

  width: auto;
  max-width: 100px;
}

.datacard-icon {
  position: absolute;
  top: 8px;
  right: 5px;
}

.transparent-icon {
  color: #a9a9a9 !important;
  opacity: 0.2;
}

.bottom-border {
  /* border-bottom: 1px solid #e8e8e8;
  padding-bottom: 5px; */
}

.container {
  padding-right: 0;
  padding-left: 0;
}

.column-size-25 {
  width: 25%;
  min-width: 25%;
}

.column-size-25-max {
  width: 25%;
  min-width: 25%;
  max-width: 25%;
}

.column-size-30 {
  width: 30%;
  min-width: 30%;
}

.column-size-20 {
  width: 20%;
  min-width: 20%;
}

.popup-container {
  display: block;
  width: 100%;
  height: 470px;
}

.popup-container div img {
  max-height: 100%;
  width: auto;
  text-align: center;
}

.modal-text-area {
  height: 460px;
  overflow: auto;
  overflow-x: hidden;
}

.center-image {
  text-align: center;
}

.popup-media-box {
  width: 110px;
}

.video-preview {
  max-height: 460px;
}

.details-label {
  color: #aaa;
  font-size: 11px;
  padding-top: 3px;
}

.flex-center video {
  height: 460px;
}

.flex-center {
  height: 460px;
}

.details-field {
  border-bottom: solid 1px #ccc;
  padding-bottom: 3px;
  font-size: 14px;
}

.media-size-label {
  font-size: 13px;
}

.card-title-popup {
  width: 110px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  font-size: 10px;
}

.auto-height {
  height: auto !important;
}
</style>
